export type SubjectFieldValuePayload = string | number | boolean | readonly string[];

export type SubjectValuesPayload = Readonly<Record<string, SubjectFieldValuePayload>>;

export type SubjectPayload = {
	readonly id: number;
	readonly facility: { readonly id: number };
	readonly type: { readonly id: number };
	readonly title: string | null;
	readonly createdAt: string;
	readonly updatedAt: string;
	readonly archivedAt?: string | null;
	readonly purgeScheduledAt?: string | null;
	readonly canWrite?: boolean;
	readonly canShare?: boolean;
	readonly values?: SubjectValuesPayload;
};

export type SubjectFetchedAction = {
	type: 'SUBJECT_FETCHED';
	payload: SubjectPayload;
};

export default (payload: SubjectPayload): SubjectFetchedAction => ({
	type: 'SUBJECT_FETCHED',
	payload,
});
